import React, { useState } from "react";
import { validateAll } from "indicative/validator";
import FloatingLabelInput from "../../../components/elements/Inputs/FloatingLabelInput";
import DrawerPanel from "../../../components/elements/DrawerPanel/DrawerPanel";
import { DbAllTerminals } from "../../../types/api.types";
import { DrawerButton } from "../../../components/elements/Button";
import { handleValidationError } from "../../../utils/formHandlers";
import { replaceTerminalApi } from "../../../redux/slice/posterminals/posterminals.api";
import Loading from "../../../components/elements/Loading/Loading";
import { ErrorToast } from "../../../components/blocks/Alert";

const getDesc = () => "Replace Damaged Terminal for communities/entities";
type Props = {
    handleClose(): void;
    row: DbAllTerminals;
};

const fields = [
    { name: "newSerialNumber", label: "New Serial Number" },
    { name: "serviceCharge", label: "Service Charge (optional)" },
] as const;

const ReplaceTerminals = (props: Props) => {
    const { handleClose, row } = props;

    const [formData, setFormData] = useState({
        newSerialNumber: "",
        serviceCharge: undefined,
    });
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [loading, setLoading] = useState(false);

    const handleTerminalReplacement = async () => {
        setLoading(true);
        try {
            const res = await replaceTerminalApi({
                ...formData,
                oldTerminalId: row.terminalId,
                fullPayment: true,
                terminalAlias: "",
            });

            console.log(res);
        } catch (error) {
            ErrorToast(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();

        const rules = {
            newSerialNumber: "required",
        };

        const message = {
            "newSerialNumber.required": "Serial Number cannot be blank",
        };

        validateAll(formData, rules, message)
            .then(() => {
                setErrors({});
                handleTerminalReplacement();
            })
            .catch(err => {
                const formattedErr = handleValidationError(err);
                setErrors(formattedErr);
            });
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = e.target;

        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <DrawerPanel
            title="Replace Terminal"
            description={getDesc()}
            open
            handleClose={handleClose}
        >
            <form onSubmit={handleSubmit}>
                {fields.map(({ label, name }) => (
                    <FloatingLabelInput
                        key={name}
                        name={name}
                        label={label}
                        value={formData[name]}
                        onChange={handleChange}
                        error={errors[name]}
                    />
                ))}
                <DrawerButton type="submit">
                    {loading ? <Loading size="xs" /> : "Submit"}
                </DrawerButton>
            </form>
        </DrawerPanel>
    );
};

export default ReplaceTerminals;
